import axios from "axios";

const instance = axios.create({
    baseURL:'https://www.7nsoft.com/api',
})

export default instance